// extracted by mini-css-extract-plugin
export default {"inputSliderWrapper":"DurationFilter-module__inputSliderWrapper___QN2KT"};